import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "priceshow-internet-configuration io-eq" }

import Product from '@/classes/Product';
import InternetConfigNumberTransfer from '@/components/order/InternetModal/InternetConfigNumberTransfer.vue';
import InternetConfigOptions from '@/components/order/InternetModal/InternetConfigOptions.vue';
import InternetConfigTelevision from '@/components/order/InternetModal/InternetConfigTelevision.vue';
import ProductCard from '@/components/product/ProductCard.vue';
import Modal from '@/components/Modal.vue';
import TelevisionPackageInterface from '@/interfaces/TelevisionPackageInterface';
import { ref, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import TelevisionProducts from '../../../public/TelevisionProducts.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceshowInternetConfigModal',
  props: {
    priceParams: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const rootModal = ref<typeof Modal>();
const product = ref<Product>();
const activeStep = ref<'numberTransfer' | 'options' | 'television'>('numberTransfer');
const errors = ref<Record<string, string | undefined>>({});

const getFormDefaults = () => {
  const customerType = props.priceParams?.customerType || 'private';

  return {
    isNumberTransfer: false,
    currentProvider: undefined,
    phoneNumber: undefined,
    allowCancellation: false,
    notIsConnectionOwner: false,
    connectionOwner: {
      firstName: undefined,
      lastName: undefined,
      postcode: undefined,
      city: undefined,
      street: undefined,
      houseNumber: undefined,
      houseNumberAddon: undefined,
    },
    addons: {
      router: customerType === 'business' ? 'router-3' : 'router-1',
      flatrates: ['flat-1'],
      ipNetworks: [],
      services: ['service-1'],
    },
    television: {
      package: undefined,
      option: undefined,
      addons: [],
    },
  };
};

const form = ref(getFormDefaults());

const routers = TelevisionProducts.router as TelevisionPackageInterface[];
const ipNetworks = TelevisionProducts.ipNetworks as TelevisionPackageInterface[];
const services = TelevisionProducts.services as TelevisionPackageInterface[];
const flatrates = TelevisionProducts.flatrates as TelevisionPackageInterface[];
const televisionPackages = TelevisionProducts.products as TelevisionPackageInterface[];
const televisionOptions = TelevisionProducts.options as TelevisionPackageInterface[];
const televisionAddons = TelevisionProducts.addons as TelevisionPackageInterface[];

watch(() => [form.value.addons, form.value.television], () => {
  if (!product.value) return;

  const productAddons = [];

  if (form.value.addons.router) {
    const router = routers.find((r) => r.id === form.value.addons.router);
    if (router) productAddons.push({ category: 'router', item: router });
  }
  if (form.value.addons.ipNetworks && form.value.addons.ipNetworks.length) {
    form.value.addons.ipNetworks.forEach((ipNetwork) => {
      const ip = ipNetworks.find((f) => f.id === ipNetwork);
      if (ip) productAddons.push({ category: 'ipNetwork', item: ip });
    });
  }
  if (form.value.addons.flatrates && form.value.addons.flatrates.length) {
    form.value.addons.flatrates.forEach((flatId) => {
      const flatrate = flatrates.find((f) => f.id === flatId);
      if (flatrate) productAddons.push({ category: 'flatrate', item: flatrate });
    });
  }
  if (form.value.addons.services && form.value.addons.services.length) {
    form.value.addons.services.forEach((serviceId) => {
      const service = services.find((s) => s.id === serviceId);
      if (service) productAddons.push({ category: 'service', item: service });
    });
  }
  if (form.value.television.package) {
    const televisionPackage = televisionPackages.find((p) => p.id === form.value.television.package);
    if (televisionPackage) productAddons.push({ category: 'television-package', item: televisionPackage });
  }
  if (form.value.television.option) {
    const option = televisionOptions.find((o) => o.id === form.value.television.option);
    if (option) productAddons.push({ category: 'television-option', item: option });
  }
  if (form.value.television.addons && form.value.television.addons.length) {
    form.value.television.addons.forEach((addonId) => {
      const televisionAddon = televisionAddons.find((a) => a.id === addonId);
      if (televisionAddon) productAddons.push({ category: 'television-addon', item: televisionAddon });
    });
  }

  if (product.value) {
    product.value.addons = productAddons;
  }
}, {
  deep: true,
});

const submitNumberTransfer = () => {
  errors.value = {};

  if (form.value.isNumberTransfer) {
    errors.value.currentProvider = !form.value.currentProvider ? 'Pflichtfeld' : undefined;
    errors.value.phoneNumber = !form.value.phoneNumber ? 'Pflichtfeld' : undefined;
    errors.value.allowCancellation = !form.value.allowCancellation ? 'Pflichtfeld' : undefined;

    if (form.value.notIsConnectionOwner) {
      errors.value['connectionOwner.firstName'] = !form.value.connectionOwner.firstName ? 'Pflichtfeld' : undefined;
      errors.value['connectionOwner.lastName'] = !form.value.connectionOwner.lastName ? 'Pflichtfeld' : undefined;
      errors.value['connectionOwner.postcode'] = !form.value.connectionOwner.postcode ? 'Pflichtfeld' : undefined;
      errors.value['connectionOwner.city'] = !form.value.connectionOwner.city ? 'Pflichtfeld' : undefined;
      errors.value['connectionOwner.street'] = !form.value.connectionOwner.street ? 'Pflichtfeld' : undefined;
      errors.value['connectionOwner.houseNumber'] = !form.value.connectionOwner.houseNumber ? 'Pflichtfeld' : undefined;
    }
  }

  const hasErrors = Object.keys(errors.value).filter((key) => !!errors.value[key]).length;
  if (hasErrors) return;
  activeStep.value = 'options';
};

const close = () => {
  rootModal.value?.close();
};

const open = (productToUse: Product) => {
  product.value = new Product({ ...productToUse.attributes });
  form.value = { ...getFormDefaults() };
  activeStep.value = 'numberTransfer';
  rootModal.value?.open();
};

const store = useStore();
const router = useRouter();
const routeQueryVars = computed(() => router.currentRoute.query);
const cartItemKey = ref(routeQueryVars.value?.cik);
const isLoading = ref(false);
const submit = () => {
  isLoading.value = true;
  store.dispatch('cart/add', {
    product: product.value,
    cartItemKey: cartItemKey.value,
    params: props.priceParams,
    additionalData: form.value,
    entry: true,
  }).then((response) => {
    const responseData = response as {
      cartEnabled: boolean,
    };

    if (responseData.cartEnabled) {
      store.commit('cart/SHOW_WIDGET');
      close();
    } else {
      isLoading.value = true;
      router.push('/bestellung/adresse/');
    }
  }).finally(() => {
    isLoading.value = false;
  });
};

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "rootModal",
    ref: rootModal,
    large: "",
    plain: "",
    "hide-close": "",
    loading: isLoading.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (activeStep.value === 'numberTransfer')
            ? (_openBlock(), _createBlock(InternetConfigNumberTransfer, {
                key: 0,
                product: product.value,
                modelValue: form.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
                errors: errors.value,
                "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((errors).value = $event)),
                onPrevious: close,
                onNext: submitNumberTransfer
              }, null, 8, ["product", "modelValue", "errors"]))
            : _createCommentVNode("", true),
          (activeStep.value === 'options')
            ? (_openBlock(), _createBlock(InternetConfigOptions, {
                key: 1,
                product: product.value,
                modelValue: form.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form).value = $event)),
                "price-params": _ctx.priceParams,
                onPrevious: _cache[3] || (_cache[3] = ($event: any) => (activeStep.value = 'numberTransfer')),
                onNext: _cache[4] || (_cache[4] = ($event: any) => (activeStep.value = 'television'))
              }, null, 8, ["product", "modelValue", "price-params"]))
            : _createCommentVNode("", true),
          (activeStep.value === 'television')
            ? (_openBlock(), _createBlock(InternetConfigTelevision, {
                key: 2,
                product: product.value,
                modelValue: form.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form).value = $event)),
                errors: errors.value,
                "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => ((errors).value = $event)),
                "price-params": _ctx.priceParams,
                onPrevious: _cache[7] || (_cache[7] = ($event: any) => (activeStep.value = 'options')),
                onNext: submit
              }, null, 8, ["product", "modelValue", "errors", "price-params"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(ProductCard, {
            product: product.value,
            preview: ""
          }, null, 8, ["product"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})